/**
 * Zoom stops for the document preview viewer (DocumentPreviewComponent):
 * the +/- buttons in the report toolbar step through these percentages.
 */
export const DocumentViewerZoomSteps = [50, 67, 75, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400] as const;
